import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultActiveKey", "activeKey", "onSelect", "children", "panels", "tabs", "className"];
// TODO: Review accessibility practices
// https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-1/tabs.html
import React, { useState, useEffect } from 'react';
import TabGroup from './TabGroup';
import TabPanelGroup from './TabPanelGroup';
import createTab from '../factories/createTab';
import createTabPanel from '../factories/createTabPanel';

var Tabs = function Tabs(_ref) {
  var defaultActiveKey = _ref.defaultActiveKey,
      activeKey = _ref.activeKey,
      onSelect = _ref.onSelect,
      children = _ref.children,
      _ref$panels = _ref.panels,
      panels = _ref$panels === void 0 ? [] : _ref$panels,
      _ref$tabs = _ref.tabs,
      tabs = _ref$tabs === void 0 ? [] : _ref$tabs,
      className = _ref.className,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(!!activeKey),
      _useState2 = _slicedToArray(_useState, 2),
      isControlled = _useState2[0],
      setIsControlled = _useState2[1];

  var _useState3 = useState(isControlled ? activeKey : defaultActiveKey),
      _useState4 = _slicedToArray(_useState3, 2),
      currentActive = _useState4[0],
      setCurrentActive = _useState4[1];

  useEffect(function () {
    setIsControlled(!!activeKey);

    if (isControlled) {
      setCurrentActive(activeKey);
    }
  }, [activeKey, isControlled]);

  var updateActiveKey = function updateActiveKey(index) {
    if (!isControlled) {
      setCurrentActive(index);
    }

    if (onSelect) {
      onSelect(index);
    }
  };

  if (children != null) {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: className
    }, unhandledProps), children);
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    className: className
  }, unhandledProps), /*#__PURE__*/React.createElement(TabGroup, null, tabs.map(function (tab, index) {
    return createTab(tab, {
      overrideProps: function overrideProps(props) {
        var eventKey = props.eventKey != null ? props.eventKey : index;
        var key = props.key != null ? props.key : eventKey;
        return {
          active: eventKey === currentActive,
          eventKey: eventKey,
          onSelect: updateActiveKey,
          key: key
        };
      }
    });
  })), /*#__PURE__*/React.createElement(TabPanelGroup, null, panels.map(function (panel, index) {
    return createTabPanel(panel, {
      overrideProps: function overrideProps(props) {
        var eventKey = props.eventKey != null ? props.eventKey : index;
        var key = props.key != null ? props.key : eventKey;
        return {
          active: eventKey === currentActive,
          key: key
        };
      }
    });
  })));
};

Tabs.displayName = 'Tabs';
export default Tabs;